'use client';

import { useSearchParams } from 'next/navigation';
import { NdrFaq } from '@/app_components/NDR/NdrFaq';
import { NdrFooter } from '@/app_components/NDR/NdrFooter';
import { NdrHeader } from '@/app_components/NDR/NdrHeader';
import { NdrStickyBanner } from '@/app_components/NDR/NdrStickyBanner';
import { ndrData } from '@/app_data/mock/ndrData';
import { detectTrafficSource, getNdrHomeUrl } from '@/app_lib/utils/ndrUtils';
import { cn } from '@/app_lib/utils/utils';

interface FaqWrapperContentProps {
  children?: React.ReactNode;
  source?: 'google' | 'bing';
}

export const FaqWrapper = ({ children, source }: FaqWrapperContentProps) => {
  const searchParams = useSearchParams();
  const allQueryParamsString =
    searchParams?.toString() || (source === 'google' ? 'src=fortune.google.organic' : 'src=fortune.bing.organic');
  const isGoogleSource = detectTrafficSource(searchParams) === 'google' || source === 'google';
  const homeUrl = getNdrHomeUrl(isGoogleSource ? 'google' : 'bing');

  const data = isGoogleSource ? ndrData.landingPages.google : ndrData.landingPages.bing;

  const stickyBarData = data.reviews.filter((item) => item.sticky === true)[0];

  // Render NDR FAQ page
  return (
    <div
      className={cn(
        'ndr-page-wrapper flex flex-col layout-ndr-gap',
        isGoogleSource ? 'is-google-source' : 'is-bing-source',
      )}
    >
      <div className='w-full layout-safe-area shadow-[4px_4px_20px_0_rgba(17,17,17,0.05)] min-h-16 '>
        <NdrHeader
          className='py-xs'
          disclaimerText={data.disclosure.text}
          disclaimerTitle={data.disclosure.title}
          homeUrl={homeUrl}
        />
      </div>
      <div className='md:container-ft md:mx-auto px-lg '>
        <div className='flex flex-col layout-grid-gap md:grid md:grid-cols-2 lg:grid-cols-[2fr_1fr]'>
          <NdrFaq
            faqs={data.faqs}
            title={data.faqTitle}
          />
          {/* Sticky Table of Contents */}
          <div className='block'>
            <div className='md:sticky top-4'>
              <NdrStickyBanner
                queryParams={allQueryParamsString}
                review={stickyBarData}
              />
            </div>
          </div>
        </div>
      </div>

      <NdrFooter footerContent={data.footer} />
      {children}
    </div>
  );
};
